/*
 * Copyright (c) 2025. Slimme Infrasoftware B.V. Apeldoorn /
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden
 * volgens de voorwaarden die zijn vastgelegd in de overeenkomst
 * tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
 * overeenkomsten tussen Slimme Infrasoftware B.V en
 * Spin in het Web B.V.
 */

/*
* leverancier.ts
* 9-3-2023 - Jelmer Jellema - Spin in het Web B.V.
*
* Leverancier uit exact
*/

import {Basemodel, ModelField} from './basemodel';

export class Leverancier extends Basemodel {
  static table = 'leverancier';
  static defaultOrder = ['naam'];
  @ModelField() override id: number = null;
  @ModelField() naam: string;
  @ModelField() werkmaatschappij_id: number;
  @ModelField() leverancierstype: 'Inhuur' | 'ZZP Pool';
  @ModelField() exact_id: string = null;

  public get bron(): 'Exact'|'ATRPlan' {
    return this.exact_id ? 'Exact' : 'ATRPlan';
  }
}
